var map = {
	"./images/bog.png": 711,
	"./images/jav.jpg": 77,
	"./images/last-supper.png": 700,
	"./images/matt.jpg": 841,
	"./images/pert.jpg": 407,
	"./images/ryan.jpg": 43,
	"./images/sliv.png": 854,
	"./images/slug.jpg": 860,
	"./images/supper.png": 485,
	"./images/ubbs.jpg": 93,
	"./images/ubbs2.jpg": 52
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 922;